// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import Summary from '../../../../../elements/Summary/Summary';
import { getFullAddress, getFullAdmin } from '../../../../../utils/address';
import { getLocalizedCountry } from '../../../../local-values/utils/countries';

import style from './PurchaseAddress.scss';

import type { Address, Country } from '../../../../../entities';
import type { LocalValuesState } from '../../../../local-values/duck';

type Props = {
  +address: Address;
  +deliveryCountry: Country;
  +localValues: LocalValuesState;
};

export const PurchaseAddressLoading = () => (
  <Summary titleIntl="order.shippingAddress.title"
           subtitleIntl="order.shippingAddress.subtitle"
           disabled/>
);

export default class PurchaseAddress extends Component<Props> {
  render() {
    const { address, deliveryCountry, localValues } = this.props;
    const countryIntl = getLocalizedCountry(deliveryCountry, this.context.intl.formatMessage, localValues.countriesMap);
    return (
      <Summary titleIntl="order.shippingAddress.title"
               subtitleIntl="order.shippingAddress.subtitle">
        <div className={style.purchaseAddressWrap}>
          <Fragment>
            <FormattedMessage id="address.name.label">{
              txt => <p className={style.title}>{txt}</p>
            }</FormattedMessage>
            <p className={style.content}>{address.firstName} {address.lastName}</p>
          </Fragment>
          <Fragment>
            <FormattedMessage id="address.idNumber.label">{
              txt => <p className={style.title}>{txt}</p>
            }</FormattedMessage>
            <p className={style.content}>{address.idNumber}</p>
          </Fragment>
          <Fragment>
            <FormattedMessage id="address.address.label">{
              txt => <p className={style.title}>{txt}</p>
            }</FormattedMessage>
            <p className={style.content}>{getFullAddress(address)}</p>
            <p className={style.content}>{getFullAdmin(address)}, {countryIntl}</p>
          </Fragment>
        </div>
      </Summary>
    );
  }
}

PurchaseAddress.propTypes = {
  address: PropTypes.object.isRequired,
  deliveryCountry: PropTypes.string.isRequired,
  localValues: PropTypes.object.isRequired,
};

PurchaseAddress.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/components/PurchaseAddress/PurchaseAddress.jsx